import { API_BASE_URL, API_PATHS, getApiPaths } from "../utils/constants/api.constants";
import axiosInstance from "../utils/authUtils";


class FerryService {

    static getFerry(item) {

        let api = `${API_BASE_URL}${API_PATHS.getFerry}`;

        const params = new URLSearchParams();

        if (item?.page) params.append("page", item.page);
        if (item?.limit) params.append("limit", item.limit);
        if (item?.id) params.append("id", item.id);
         if (item?.from) params.append("from", item.from);
          if (item?.to) params.append("to", item.to);
       
        if ([...params].length > 0) {
            api += `?${params.toString()}`;
        }

        return axiosInstance.get(api,item);
    }

    static addFerry(data) {
        let api = '';
        api = `${API_BASE_URL}${API_PATHS.addFerry}`;
        return axiosInstance
            .post(api, data)

    }

    static editFerry(data) {

        let api = '';
        api = `${API_BASE_URL}${API_PATHS.editFerry}`;
        return axiosInstance
            .put(api, data)

    }

    static deleteFerry(id) {
        let api = '';

        api = `${API_BASE_URL}${API_PATHS.deleteFerry}?id=${id}`;

        return axiosInstance
            .delete(api)
    }


}

export default FerryService;
